/**
 * Strip team- / family- / party- prefixes for display registry lookup.
 */
export function normalizeGameType(gameType: string): string {
  if (gameType.startsWith('team-')) return gameType.replace('team-', '');
  if (gameType.startsWith('family-')) return gameType.replace('family-', '');
  if (gameType.startsWith('party-')) return gameType.replace('party-', '');
  return gameType;
}
